{
  "level": "bs0607mv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs0607mv",
    "objects": "AREAS.E3:bs0607mv.e3",
    "mesh": "TREES.E3:bs0607mv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 1548,
      "centroid": [
        -2709.999755859375,
        -4371.7685546875,
        1104.623779296875
      ],
      "bbox_min": [
        -2719.999755859375,
        -4371.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4371.7685546875,
        1112.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 0.0,
        "height_z": 16.0,
        "door_width": 20.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2699.999755859375,
          -4371.7685546875,
          1096.623779296875
        ],
        [
          -2699.999755859375,
          -4371.7685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4371.7685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4371.7685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4371.7685546875,
          1112.623779296875
        ],
        [
          -2719.999755859375,
          -4371.7685546875,
          1112.623779296875
        ],
        [
          -2699.999755859375,
          -4371.7685546875,
          1112.623779296875
        ],
        [
          -2699.999755859375,
          -4371.7685546875,
          1112.623779296875
        ]
      ],
      "plane_distance": 4371.7686,
      "authentic_texture": "warehouswin-m"
    }
  ],
  "tutorial_messages": []
}